import React from 'react'

export default function DietitionProfile() {
  return (
    <div>
      <p>this is dietition profile</p>
    </div>
  )
}
